<template>
	<div
		class="inline-flex items-center font-semibold border rounded py-none px-xs gap-xxs text-xxs bg-error-50 text-error-600 border-error-200"
		data-testid="out-of-stock-badge"
	>
		Out of stock
	</div>
</template>
